import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { URL } from "../../../constants/URL";
import CS from "../../../services/commonService";
import BreadCrumbs from "../../common/breadcrumbs";
import { useStore } from "../../../zustand/store";
import { useFormik } from "formik";
import Select from "react-select";
import Datetime from "react-datetime";
import UploadAndCropImageModal from "../../common/UploadAndCropImageModal";
import dataUrlToFile from "../../common/urlToFile";
import qs from "qs";
import {
	useCountryCodes,
	useGetUserDetails,
	useSaveUserInfo,
	useUpdateUserCredentials,
} from "../../../queryHooks";
import moment from "moment";
import {
	userCredentialsSchema,
	userInformationSchema,
} from "../../../validations";
import PhoneNumber from "../../common/PhoneNumber";
import PhoneInput from "react-phone-input-2";
//  Component starts
const UpdateUser = () => {
	const setLoading = useStore((state) => state.setLoading);
	const { slug } = useParams();
	const navigate = useNavigate();
	//	State values
	const [countryCode, setCountryCode] = useState({ label: "+1", value: "+1" });
	const [codeOptions, setCodeOptions] = useState([]);

	const [cropAndUploadImageModel, setCropAndUploadImageModel] = useState(false);
	const [newphoto, setNewPhoto] = useState();
	const [file, setFileData] = useState();
	const [credsDataChanged, setCredsDataChanged] = useState(false);

	const [basicFormData, setBasicFormData] = useState({
		firstName: "",
		lastName: "",
		DOB: "",
		referralCode: "",
	});

	const [credentialsFormData, setCredentialsFormData] = useState({
		email: "",
		mobile: "",
		username: "",
	});

	const { data: countryCodesData } = useCountryCodes();

	useEffect(() => {
		if (countryCodesData && countryCodesData.status === "success") {
			let phoneCodes = [];
			for (const object of countryCodesData.data) {
				phoneCodes.push({
					label: `+${object.phone_code}`,
					value: object.id,
				});
			}
			setCodeOptions(phoneCodes);
		}
	}, [countryCodesData]);

	const {
		data: dataUserDetails,
		isLoading: getUserDetailsLoading,
		refetch,
	} = useGetUserDetails(slug);

	useEffect(() => {
		if (dataUserDetails?.status === "success") {
			setBasicFormData({
				firstName: dataUserDetails?.data?.first_name,
				lastName: dataUserDetails?.data?.last_name,
				DOB: moment(dataUserDetails?.data?.date_of_birth).format("MM-DD-YYYY"),
				referralCode: dataUserDetails?.data?.referral_code,
			});
			setNewPhoto(dataUserDetails?.data?.profile_image_url);
			setCredentialsFormData({
				email: dataUserDetails?.data?.email,
				// mobile: dataUserDetails?.data?.mobile.substring(2),
				mobile: dataUserDetails?.data?.mobile,
				username: dataUserDetails?.data?.username,
			});
		}
	}, [dataUserDetails]);

	const {
		mutateAsync: saveUserInfoAsync,
		error: errorUserInfo,
		data: userInfoData,
		isLoading: saveUserLoading,
	} = useSaveUserInfo();

	useEffect(() => {
		if (errorUserInfo) {
			CS.showErrorMessage(
				errorUserInfo?.response?.data?.message || errorUserInfo?.data?.message
			);
		}
	}, [errorUserInfo]);

	useEffect(() => {
		if (userInfoData) {
			if (userInfoData?.status === "success") {
				CS.showSuccessMessage(userInfoData?.message);
				refetch();
			} else if (userInfoData.status === "fail") {
				CS.showErrorMessage(userInfoData?.message);
			}
		}
	}, [userInfoData]);

	const {
		values: valuesBasic,
		errors: errorsBasic,
		touched: touchedBasic,
		handleChange: handleChangeBasic,
		handleSubmit: handleSubmitBasic,
	} = useFormik({
		initialValues: basicFormData,
		enableReinitialize: true,
		validationSchema: userInformationSchema,
		onSubmit: () => {
			const _formData = new FormData();
			_formData.append("first_name", valuesBasic.firstName);
			_formData.append("last_name", valuesBasic.lastName);
			_formData.append("referral_code", valuesBasic.referralCode);
			_formData.append(
				"date_of_birth",
				moment(valuesBasic.DOB).format("YYYY-MM-DD")
			);

			if (file) {
				_formData.append("profile_image", file);
			}
			saveUserInfoAsync({ userId: slug, body: _formData });
		},
	});

	const {
		mutateAsync: updateUserCredentialsAsync,
		data: updateUserCredsdata,
		error: errorUpdateUserCreds,
		isLoading: updateUserCredsLoading,
	} = useUpdateUserCredentials();

	useEffect(() => {
		if (errorUpdateUserCreds) {
			CS.showErrorMessage(
				errorUpdateUserCreds?.response?.data?.message ||
					errorUpdateUserCreds?.data?.message
			);
		}
	}, [errorUpdateUserCreds]);

	useEffect(() => {
		if (updateUserCredsdata) {
			if (updateUserCredsdata?.status === "success") {
				CS.showSuccessMessage(updateUserCredsdata?.message);
				refetch();
			} else if (updateUserCredsdata?.status === "fail") {
				CS.showErrorMessage(updateUserCredsdata?.message);
			}
		}
	}, [updateUserCredsdata]);

	const {
		values: valuesCreds,
		errors: errorsCreds,
		touched: touchedCreds,
		handleChange: handleChangeCreds,
		handleSubmit: handleSubmitCreds,
	} = useFormik({
		validationSchema: userCredentialsSchema,
		initialValues: credentialsFormData,
		enableReinitialize: true,
		onSubmit: (value) => {
			let body = {
				...(value.email?.trim() !== dataUserDetails?.data?.email && {
					email: value.email?.trim(),
				}),
				...(value.username?.trim() !== dataUserDetails?.data?.username && {
					username: value.username?.trim(),
				}),
				...(value.mobile.toString().trim() !==
					dataUserDetails?.data?.mobile && {
					mobile: value.mobile.toString().trim(),
				}),
			};

			if (Object.keys(body).length > 0)
				updateUserCredentialsAsync({
					userId: slug,
					role: "user",
					body,
				});
		},
	});

	useEffect(() => {
		let body = {
			...(valuesCreds.email?.trim() !== dataUserDetails?.data?.email && {
				email: valuesCreds.email?.trim(),
			}),
			...(valuesCreds.username?.trim() !== dataUserDetails?.data?.username && {
				username: valuesCreds.username?.trim(),
			}),
			...(valuesCreds.mobile.toString().trim() !==
				dataUserDetails?.data?.mobile?.substring(2) && {
				mobile: valuesCreds.mobile.toString().trim(),
			}),
		};

		if (Object.keys(body).length > 0) {
			setCredsDataChanged(false);
		} else {
			setCredsDataChanged(true);
		}
	}, [valuesCreds, dataUserDetails?.data]);

	useEffect(() => {
		setLoading(
			getUserDetailsLoading || saveUserLoading || updateUserCredsLoading
		);
	}, [getUserDetailsLoading, saveUserLoading, updateUserCredsLoading]);

	//handle image cropped function
	const handleImageCropped = async (image) => {
		if (image) {
			const fileObj = dataUrlToFile(image);
			setFileData(fileObj);
			setNewPhoto(image);
		}
	};

	return (
		<>
			<BreadCrumbs
				title={"Users Management"}
				data={[
					{ label: "Users", path: URL.onboarderedUsers },
					{
						label: `${dataUserDetails?.data?.first_name} ${dataUserDetails?.data?.last_name}`,
						path: `${URL.onboarderedUsers}/${slug}`,
					},
					{ label: "Update User" },
				]}
			/>
			<form onSubmit={handleSubmitBasic}>
				<div className="card restaurant-card mb-5">
					<div className="modal-header p-0 pb-3 mb-4 w-100">
						<h5 className="box-title modal-title">
							<i className="bx bx-user mr-1"></i> User Info
						</h5>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="row align-items-end">
								<div className="col-md-12">
									<div
										className="user-title-info user-details"
										style={{
											display: "flex",
											justifyContent: "space-between",
										}}
									>
										<div className="col-md-2 mb-3">
											<div className="edit-image ml-0">
												<div className="user-image">
													<div>
														<div
															onClick={() => setCropAndUploadImageModel(true)}
														>
															{CS.renderImageUrl(newphoto || "")}
														</div>
													</div>
													<label
														className="img-upload"
														htmlFor="attach-file"
														onClick={() => setCropAndUploadImageModel(true)}
													>
														<em className="bx bxs-edit-alt" />
													</label>
													<UploadAndCropImageModal
														show={cropAndUploadImageModel}
														handleImageCropped={handleImageCropped}
														handleClose={() =>
															setCropAndUploadImageModel(false)
														}
													/>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="restaurantName">
													First Name
													<sup className="text-danger">*</sup>
												</label>
												<div className="w-100">
													<input
														maxLength="255"
														type="text"
														className="form-control"
														id="firstName"
														name="firstName"
														placeholder="Enter first name"
														value={valuesBasic.firstName}
														onChange={handleChangeBasic}
													/>
													<span className="text-danger d-block">
														{errorsBasic.firstName && touchedBasic.firstName
															? errorsBasic.firstName
															: null}
													</span>
												</div>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="restaurantName">
													Last Name
													<sup className="text-danger">*</sup>
												</label>
												<div className="w-100">
													<input
														maxLength="255"
														type="text"
														className="form-control"
														id="lastName"
														name="lastName"
														placeholder="Enter last name"
														value={valuesBasic.lastName}
														onChange={handleChangeBasic}
													/>
													<span className="text-danger d-block">
														{errorsBasic.lastName && touchedBasic.lastName
															? errorsBasic.lastName
															: null}
													</span>
												</div>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="label xl-label">
													Date Of Birth<sup className="text-danger">*</sup>
												</label>
												<Datetime
													className="d-block dob-left"
													inputProps={{ placeholder: "Select date of birth" }}
													onChange={(date) => {
														let event = {
															target: {
																name: "DOB",
																value: moment(new Date(date)).format(
																	"YYYY-MM-DD"
																),
															},
														};
														handleChangeBasic(event);
													}}
													value={valuesBasic.DOB}
													closeOnSelect={true}
													timeFormat={null}
													dateFormat={"MM-DD-YYYY"}
												/>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="restaurantName">
													Referral Code
													<sup className="text-danger">*</sup>
												</label>
												<div className="w-100">
													<input
														maxLength="255"
														type="text"
														className="form-control"
														id="referralCode"
														name="referralCode"
														placeholder="Enter referral code"
														value={valuesBasic.referralCode}
														onChange={(e) => {
															let event = {
																target: {
																	name: "referralCode",
																	value: e.target.value.toUpperCase(),
																},
															};
															handleChangeBasic(event);
														}}
													/>
													<span className="text-danger d-block">
														{errorsBasic.referralCode &&
														touchedBasic.referralCode
															? errorsBasic.referralCode
															: null}
													</span>
												</div>
											</div>
											<div className="col-md-12 mt-4 btn-blocks text-right">
												<button
													type="submit"
													className="btn btn-primary glow-primary mr-4"
												>
													Save Changes
												</button>
												<Link
													className="btn btn-outline-primary"
													to={`${URL.onboarderedUsers}/${slug}`}
												>
													Cancel
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
			<form onSubmit={handleSubmitCreds}>
				<div className="card profile-card mb-5">
					<div className="modal-header p-0 pb-3 mb-4 w-100">
						<h5 className="box-title modal-title">
							<i className="bx bx-user mr-1"></i> User Credentials
						</h5>
					</div>
					<div className="row align-items-center">
						<div className="col-md-12 mt-3">
							<div className="row">
								<div className="form-group col-md-6 mb-md-4 mb-3">
									<label className="mb-1" htmlFor="emailId">
										Email<sup className="text-danger">*</sup>
									</label>
									<div className="w-100">
										<input
											className="form-control"
											id="email"
											name="email"
											type="email"
											placeholder="Enter email"
											value={valuesCreds.email}
											onChange={handleChangeCreds}
										/>
									</div>
									<span className="text-danger d-block">
										{errorsCreds.email && touchedCreds.email
											? errorsCreds.email
											: null}
									</span>
								</div>
								<div className="form-group col-md-6 mb-md-4 mb-3">
									<div className="row justify-content-center">
										{/* <div className="col-md-3">
											<label className="mb-1" htmlFor="phonelId">
												Code<sup className="text-danger">*</sup>
											</label>
											<Select
												className="default-select"
												value={countryCode}
												options={codeOptions}
												onChange={(val) => setCountryCode(val)}
												isDisabled="true"
											></Select>
										</div>
										<div className="col-md-9">
											<label className="mb-1" htmlFor="phonelId">
												Phone Number<sup className="text-danger">*</sup>
											</label>
											<input
												className="form-control"
												type="number"
												value={valuesCreds.mobile}
												onChange={handleChangeCreds}
												id="mobile"
												name="mobile"
												placeholder="Enter phone number"
												onInput={(e) =>
													(e.target.value = e.target.value.slice(0, 10))
												}
											/>
											<span className="text-danger d-block">
												{errorsCreds.mobile && touchedCreds.mobile
													? errorsCreds.mobile
													: null}
											</span>
										</div> */}
										<div className="col-md-12">
											<label className="mb-1" htmlFor="phonelId">
												Phone Number<sup className="text-danger">*</sup>
											</label>
											<PhoneNumber
												value={valuesCreds.mobile}
												onChange={(val) => {
													console.log(val);
													let event = {
														target: { name: "mobile", value: val ? val : "" },
													};
													handleChangeCreds(event);
												}}
											/>
											{/* <span className="text-danger d-block">
												{errorsCreds.mobile && touchedCreds.mobile
													? errorsCreds.mobile
													: null}
											</span> */}

											{/* <PhoneInput country="us" disableDropdown={true} disableCountryCode={true} onChange={val => console.log("==>",val)} /> */}
										</div>
									</div>
									<span className="text-danger d-block">
										{errorsCreds.mobile && touchedCreds.mobile
											? errorsCreds.mobile
											: null}
									</span>
								</div>
								<div className="form-group col-md-6 mb-md-4 mb-3">
									<label className="mb-1" htmlFor="emailId">
										Username<sup className="text-danger">*</sup>
									</label>
									<div className="w-100">
										<input
											className="form-control"
											id="username"
											name="username"
											type="text"
											placeholder="Enter username"
											value={valuesCreds.username}
											onChange={handleChangeCreds}
										/>
									</div>
									<span className="text-danger d-block">
										{errorsCreds.username && touchedCreds.username
											? errorsCreds.username
											: null}
									</span>
								</div>
							</div>
							<div className="col-md-12 mt-4 btn-blocks text-right">
								<button
									type="submit"
									disabled={credsDataChanged}
									className="btn btn-primary glow-primary mr-4"
								>
									Save Changes
								</button>
								<Link
									className="btn btn-outline-primary"
									to={`${URL.onboarderedUsers}/${slug}`}
								>
									Cancel
								</Link>
							</div>
						</div>
					</div>
				</div>
			</form>
		</>
	);
};

export default UpdateUser;
